const padZero = (val: number) => {
    return Math.floor(val).toString().padStart(2, '0')
};

export const SECOND = 1000;
export const MINUTE = 60 * SECOND;
export const HOUR = 60 * MINUTE;

export const formatDigitalHours = (ms: number) => {
    return padZero(ms / HOUR);
};

export const formatDigitalMinutes = (ms: number) => {
    return padZero((ms / MINUTE) % 60);
};
